<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-single-select-edit-control [allowClearSelectionOption]="false" formControlName="applyPaymentsToInvoice"
                                                    [(ngModel)]="model.data.applyPaymentsToInvoice">
                        <wbo-select-options>
                            <wbo-select-option [value]="false" label="wbo.account-type.edit.option.applyPaymentsToInvoice.doNotApplyCharges">
                            </wbo-select-option>
                            <wbo-select-option [value]="true" label="wbo.account-type.edit.option.applyPaymentsToInvoice.applyToChargesFirstInFirstOut">
                            </wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                    <wbo-numeric-edit-control formControlName="paymentLimit"
                                              [(ngModel)]="model.data.paymentLimit"></wbo-numeric-edit-control>
                </fui-tandem-field>
            </fui-column>
            <fui-column>
                <fui-tandem-field>
                    <wbo-checkbox-edit-control formControlName="lockOnOverdue" [(ngModel)]="model.data.lockOnOverdue">
                    </wbo-checkbox-edit-control>
                    <wbo-checkbox-edit-control formControlName="unlockOnPayment" [(ngModel)]="model.data.unlockOnPayment">
                    </wbo-checkbox-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
